import { Permission, PermissionGrant } from '../../graphql'

export function checkPermissions( userPermissions: PermissionGrant[], permissionsToCheck: Permission[], operator?: 'every' | 'any' ): boolean {
	if ( !userPermissions?.length ) {
		return false
	}

	if ( !permissionsToCheck?.length ) {
		return true
	}

	const grantedPermissionNames = userPermissions.map( ( grant ) => grant.permission )

	if ( operator === 'any' ) {
		return permissionsToCheck.some( ( permission ) => grantedPermissionNames.includes( permission ) )
	}

	return permissionsToCheck.every( ( permission ) => grantedPermissionNames.includes( permission ) )
}
